const POST_METHOD_COMPATIBILITY_PATCH = Symbol.for('eInvitation.postMethodCompatibility.v2')
const METHOD_OVERRIDE_PARAM = '__method'
const POST_TUNNELED_METHODS = new Set(['PATCH', 'PUT', 'DELETE'])

function isRequest(value) {
  return typeof Request !== 'undefined' && value instanceof Request
}

function getMethod(input, init) {
  return String(init?.method || (isRequest(input) ? input.method : 'GET')).trim().toUpperCase()
}

function getRequestUrl(input) {
  try {
    const value = isRequest(input) ? input.url : String(input)
    return new URL(value, window.location.href)
  } catch {
    return null
  }
}

function buildPostRequest(input, init, overriddenUrl) {
  const nextInit = {
    ...init,
    method: 'POST',
  }

  if (!isRequest(input)) {
    return {
      input: overriddenUrl.toString(),
      init: nextInit,
    }
  }

  const requestInit = {
    method: 'POST',
    headers: init?.headers || input.headers,
    body: init?.body !== undefined ? init.body : input.body,
    mode: init?.mode || input.mode,
    credentials: init?.credentials || input.credentials,
    cache: init?.cache || input.cache,
    redirect: init?.redirect || input.redirect,
    referrer: init?.referrer || input.referrer,
    referrerPolicy: init?.referrerPolicy || input.referrerPolicy,
    integrity: init?.integrity || input.integrity,
    keepalive: init?.keepalive ?? input.keepalive,
    signal: init?.signal || input.signal,
  }

  return {
    input: new Request(overriddenUrl.toString(), requestInit),
    init: undefined,
  }
}

export function installPostMethodCompatibility() {
  if (typeof window === 'undefined' || globalThis[POST_METHOD_COMPATIBILITY_PATCH]) return

  const nativeFetch = window.fetch.bind(window)

  window.fetch = (input, init = {}) => {
    const requestedMethod = getMethod(input, init)
    if (!POST_TUNNELED_METHODS.has(requestedMethod)) {
      return nativeFetch(input, init)
    }

    const url = getRequestUrl(input)
    if (!url) return nativeFetch(input, init)

    // The deployed reverse proxy accepts only GET, HEAD, and POST. Send every
    // update/delete operation as POST over the network and let Express restore
    // the intended method before route matching.
    url.searchParams.set(METHOD_OVERRIDE_PARAM, requestedMethod)
    const request = buildPostRequest(input, init, url)
    return nativeFetch(request.input, request.init)
  }

  globalThis[POST_METHOD_COMPATIBILITY_PATCH] = true
}

installPostMethodCompatibility()
